import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.prefersReducedMotion || !("IntersectionObserver" in window)) {
      this.element.classList.add("is-visible")
      return
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible")
          this.observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" })

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
